<template>
  <header class="header" :class="$route.name">
    <div class="header-content">
      <div class="header-logo pointer" @click="goIndex">
        <i class="iconfont iconjitulogo_fanbai"></i>
        <i class="iconfont iconlogo_kaifangpingtaifanbai"></i>
      </div>
      <div class="header-menu">
        <div
          class="header-menu-item"
          v-for="(item, index) in menuList"
          :key="index"
          :class="{ active: $route.path === item.path || $route.path.includes(item.path), active_font_color:  $route.path === item.path  || $route.path.includes(item.path) }"
          @click="tabClick(index, item.path)"
        >
          {{ item.title }}
        </div>
      </div>
      <div style="display: flex;align-items: center;">
        <div class="top-btn red width-10" @click="toControl"><span>控制台</span></div>
        <div class="header-btn" v-if="!token">
          <div class="top-btn btn-hover" @click="goLogin"><span>登录</span></div>
          <div class="top-btn btn-hover" @click="goRegister"><span>注册</span></div>
        </div>
        <div class="header-user" v-else>
          <el-dropdown>
            <span class="el-dropdown-link">
              <img src="@/assets//images/register/head2.png" alt="" />
              <span class="name">{{ user.account }}</span>
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="dropdown">
              <el-dropdown-item @click.native="logOut">
                <i class="iconfont icondaohangshezhi_tuichumoren"></i>
                退出</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { logOut } from '@/api'
import { RESPONSE_SUCCESS } from '@/constants'
export default {
  data() {
    return {
      menuList: [
        { title: '首页', path: '/home' },
        { title: '解决方案', path: '/solution' },
        { title: 'API文档', path: '/apiDoc' },
        { title: '帮助中心', path: '/helpCenter' },
        { title: '平台公告', path: '/aboutUs' },
      ]
    }
  },
  computed: {
    ...mapGetters(['token', 'user']),
  },
  methods: {
    ...mapActions(['LOGIN_OUT']),
    tabClick(index, path) {
      //去掉注册界面跳控制台的问题
      if (this.$route.name === 'Register' && path === '/control/personalCenter') {
        return this.$message.warning('您尚未登入，请您先注册')
      }
      this.$router.push({ path })
      let event = 'Home'
      switch(index) {
        case 0:
          event = 'Home'
          break;
        case 1:
          event = 'Solution'
          break;
        case 2:
          event = 'ApiDoc'
          break;
        case 3:
          event = 'HelpCenter'
          break;
        case 4:
          event = 'Notice'
          break;
      }
      window._hmt.push(['_trackCustomEvent', event]);
    },
    /**
     * @description 去首页
     */
    goIndex() {
      this.$router.push({ path: '/' })
    },
    toControl() {
      window._hmt.push(['_trackCustomEvent', 'Control']);
      this.$router.push({ path: '/control/personalCenter' })
    },
    goRegister() {
      window._hmt.push(['_trackCustomEvent', 'Register']);
      this.$router.push({ path: '/register' })
    },
    goLogin() {
      window._hmt.push(['_trackCustomEvent', 'Login']);
      this.$router.push({ path: '/login' })
    },
    async logOut() {
      const res = await logOut({})
      if (res.code === RESPONSE_SUCCESS) {
        this.LOGIN_OUT().then(() => {
          this.$router.push({ path: '/login' })
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 105;
  background-color: #fff;
  height: 64px;
  box-shadow: 0px 10px 10px -15px #000;
  .header-content {
    min-width: 1320px;
    justify-content: space-around;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .header-logo {
      color: #E60000;
      .iconjitulogo_fanbai {
        font-size: 23px;
      }
      .iconlogo_kaifangpingtaifanbai {
        font-size: 23px;
        border-left: 1px solid #E60000;
        margin-left: 20px;
        padding-left: 20px;
      }
    }
    .pointer {
      cursor: pointer;
    }
    .header-menu {
      width: 800px;
      height: 100%;
      line-height: 64px;
      margin-left: 20px;
      .active_font_color {
        color: #E60000 !important;
      }
      .header-menu-item {
        display: inline-block;
        margin-left: 60px;
        cursor: pointer;
        position: relative;
        color: #2b2b2b;
        font-weight: 600;
        &.active:after {
          content: '';
          width: 30px;
          height: 4px;
          background: #E60000;
          border-radius: 2px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    .header-btn {
      display: flex;
      width: 200px;
      align-items: center;
      margin-left: 30px;
      .btn-hover:hover {
        color: #E60000;
        padding: 2px !important;
        font-size: 18px;
      }
    }
    .top-btn {
      font-size: 16px;
      padding: 4px;
      text-align: center;
      margin: 5px;
      font-weight: 600;
    }
    .top-btn:hover {
      cursor: pointer;
    }
    .width-10 {
      width: 70px;
    }
    .red {
      border: 1px solid;
      border-radius: 4px;
      background-color: #E60000;
      color:#fff;
      border-color: #E60000
    }
    .red:hover {
      box-shadow: 0px 0px 3px 3px rgba(230, 0, 0, 0.77);
    }
    .header-user {
      margin-left: 30px;
      .el-dropdown-link {
        // color: #fff;
        img {
          vertical-align: middle;
          width: 28px;
        }
        .iconfont {
          font-size: 14px;
        }
        .name {
          margin: 0 10px;
        }
      }
      .el-dropdown-link:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
